<template>
  <div>
    <p v-for="(r, i) in row" :key="i">
      <span v-if="typeof r.margin === 'number'">~ {{ r.margin && r.margin.toFixed(2) }}</span>
    </p>
  </div>
</template>

<script>

export default {
  name: 'CalcRatesTableCellMargin',
  props: {
    row: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellMargin.vue